import { useIntl } from 'react-intl';
import { useConsent } from '../context/ConsentContext';
import '../css/CookieConsentBanner.css';

const CookieConsentBanner = () => {
  const intl = useIntl();
  const { consent, setConsent } = useConsent();

  if (consent !== null) return null;

  return (
    <div className="consent-banner" role="dialog" aria-live="polite">
      <p className="consent-banner-text">
        {intl.formatMessage({ id: 'consent.text' })}
      </p>
      <div className="consent-banner-actions">
        <button className="consent-btn consent-btn-decline" onClick={() => setConsent('declined')}>
          {intl.formatMessage({ id: 'consent.decline' })}
        </button>
        <button className="consent-btn consent-btn-accept" onClick={() => setConsent('accepted')}>
          {intl.formatMessage({ id: 'consent.accept' })}
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;